<div>
  <div class="banner flex flex-row justify-between">
    <div class="ml-2">
      <h1 class="info-header">Account Information</h1>
      <p class="info-subtitle">Edit your name, address, etc.</p>
    </div>
    <button
      mat-raised-button
      color="accent"
      (click)="onSave()"
      [disabled]="userForm.invalid || userProfileForm.invalid"
      class="self-end mb-1 mr-2"
    >
      Save All
    </button>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="loading" color="accent">
  </mat-progress-bar>

  <div class="grid lg:grid-cols-2 gap-6 mt-4 mx-2 items-start">
    <mat-card>
      <mat-card-header>
        <mat-card-title> Contact Details</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="userForm">
          <div class="grid md:grid-cols-2 gap-2">
            <mat-form-field>
              <mat-label> First Name</mat-label>
              <input
                matInput
                type="text"
                formControlName="firstName"
                maxlength="200"
              />
              <mat-error *ngIf="this.userForm.controls.firstName.invalid">
                First name is required.
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label> Last Name</mat-label>
              <input
                matInput
                type="text"
                formControlName="lastName"
                maxlength="200"
              />
              <mat-error *ngIf="this.userForm.controls.lastName.invalid">
                Last name is required.
              </mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label> Email Address</mat-label>
              <input
                matInput
                type="email"
                formControlName="email"
                email="true"
              />
              <mat-error *ngIf="this.userForm.controls.email.invalid">
                Email is required.
              </mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label> Phone Number</mat-label>
              <input
                matInput
                type="tel"
                [formControl]="this.userForm.controls.phone"
                placeholder="555-123-9876"
                mask="000-000-0000"
              />
              <mat-error *ngIf="this.userForm.controls.phone.invalid">
                Phone number is required.
              </mat-error>
            </mat-form-field>
          </div>
        </form>
      </mat-card-content>

      <mat-card-actions align="end">
        <div class="grid grid-cols-3 gap-2">
          <button mat-raised-button (click)="clearForm('USERFORM')">
            Clear
          </button>
          <button mat-raised-button (click)="resetForm('USERFORM')">
            Reset
          </button>
          <button
            mat-raised-button
            color="accent"
            (click)="onSave('USERFORM')"
            [disabled]="userForm.invalid"
          >
            Save
          </button>
        </div>
      </mat-card-actions>
    </mat-card>

    <mat-card>
      <mat-card-header>
        <mat-card-title> Address </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="userProfileForm">
          <mat-form-field class="w-full">
            <mat-label> Street Address</mat-label>
            <input matInput type="text" formControlName="street" />
            <mat-error *ngIf="this.userProfileForm.controls.street.invalid">
              Street address is required.
            </mat-error>
          </mat-form-field>

          <div>
            <mat-form-field class="w-full">
              <mat-label> Address Line 2</mat-label>
              <input matInput type="text" formControlName="address2" />
            </mat-form-field>
          </div>

          <div class="grid md:grid-cols-3 gap-2">
            <mat-form-field>
              <mat-label> City </mat-label>
              <input matInput type="text" formControlName="city" />
              <mat-error *ngIf="this.userProfileForm.controls.city.invalid">
                City is required.
              </mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label> State</mat-label>
              <mat-select formControlName="state">
                @for (state of states; track state) {
                <mat-option [value]="state">{{ state }}</mat-option>
                }
              </mat-select>
              <mat-error *ngIf="this.userProfileForm.controls.state.invalid">
                State is required.
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label> Zipcode</mat-label>
              <input
                matInput
                #zipCode
                type="text"
                formControlName="zipCode"
                maxlength="5"
              />
              <mat-error *ngIf="this.userProfileForm.controls.zipCode.invalid">
                Zipcode is required.
              </mat-error>
              <mat-hint align="end">{{ zipCode.value.length }} / 5</mat-hint>
            </mat-form-field>
          </div>
        </form>
      </mat-card-content>

      <mat-card-actions align="end">
        <div class="grid grid-cols-3 gap-2">
          <button mat-raised-button (click)="clearForm('USERPROFILEFORM')">
            Clear
          </button>

          <button mat-raised-button (click)="resetForm('USERPROFILEFORM')">
            Reset
          </button>

          <button
            mat-raised-button
            color="accent"
            (click)="onSave('USERPROFILEFORM')"
            [disabled]="userProfileForm.invalid"
            class="ml-2"
          >
            Save
          </button>
        </div>
      </mat-card-actions>
    </mat-card>

    <mat-card>
      <mat-card-header>
        <mat-card-title> Change Password </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="editPasswordForm">
          <div>
            <mat-form-field class="w-full">
              <mat-label> Current Password </mat-label>
              <input
                matInput
                [type]="hideCurrentPassword() ? 'password' : 'text'"
                formControlName="currentPassword"
                maxlength="250"
              />
              <button
                mat-icon-button
                matSuffix
                (click)="clickCurrPass($event)"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideCurrentPassword()"
              >
                <mat-icon>{{
                  hideCurrentPassword() ? "visibility_off" : "visibility"
                }}</mat-icon>
              </button>

              <mat-error
                *ngIf="editPasswordForm.controls.currentPassword.touched"
              >
                Current password is required.
              </mat-error>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field class="w-full">
              <mat-label> New Password</mat-label>
              <input
                [type]="hideNewPassword() ? 'password' : 'text'"
                matInput
                formControlName="password"
                maxlength="250"
              />
              <button
                mat-icon-button
                matSuffix
                (click)="clickNewPass($event)"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideNewPassword()"
              >
                <mat-icon>{{
                  hideNewPassword() ? "visibility_off" : "visibility"
                }}</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field class="w-full">
              <mat-label> Confirm New Password </mat-label>
              <input
                [type]="hideConfirmNewPassword() ? 'password' : 'text'"
                matInput
                maxlength="250"
                formControlName="confirmPassword"
              />
              <button
                mat-icon-button
                matSuffix
                (click)="clickConfirmNewPass($event)"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideConfirmNewPassword()"
              >
                <mat-icon>
                  {{
                    hideConfirmNewPassword() ? "visibility_off" : "visibility"
                  }}
                </mat-icon>
              </button>
            </mat-form-field>
          </div>

          <p
            *ngIf="
            editPasswordForm.controls.password.touched &&
            editPasswordForm.controls.password.errors?.['requirementsNotMet']"
            class="w-full"
          >
            Password must be at least 8 characters and contain at least one
            number, one uppercase letter, and one lowercase letter.
          </p>
          <p
            *ngIf="
            editPasswordForm.controls.password.touched &&
            editPasswordForm.controls.confirmPassword.touched && editPasswordForm.controls.password.errors?.['passwordMatch']"
          >
            Passwords do not match.
          </p>
        </form>
      </mat-card-content>

      <mat-card-actions align="end">
        <button mat-raised-button (click)="editPasswordForm.reset()">
          Clear
        </button>

        <button
          mat-raised-button
          color="accent"
          (click)="onChangePassword()"
          [disabled]="editPasswordForm.invalid"
          class="ml-2"
        >
          Change Password
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
